import { Component, OnInit, ViewChild } from '@angular/core';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { WindowService } from 'src/shared/providers/window.service';

import { scrollContentWidth } from 'src/shared/components/scroll-wrapper/scroll-wrapper.component';
import { EmployerService } from 'src/providers/employer/employer';
import { Util } from 'src/shared/util/util';

@Component({
    templateUrl: 'campaign.html',
    standalone: false
})

export class EmployerCampaignPage implements OnInit {

  readonly desktopWidthContent: string = scrollContentWidth.LARGE;
  rows: any;
  headers: any = this.buildHeaders();
  campaigns: Partial<{
    name: string,
    frequency: string,
    description: string
  }>[] = [];
  loaded: boolean;
  @ViewChild('tidyTable') tidyTable: any;

  constructor(
    private navCtrl: CustomNavController,
    private employerService: EmployerService,
    private util: Util,
    public windowService: WindowService
  ) {}

  async ngOnInit() {
    try {
      this.campaigns = await this.employerService.listCampaigns();
      this.rows = this.buildRows();
      this.headers = this.buildHeaders();
      this.loaded = true;
    } catch (_err) {
      // Silent error handling
    }
  }

  buildHeaders() {
    return [
      'Name',
      'Frequency',
      'Description',
      'Status'
    ];
  }

  buildRows() {
   const dataSrc = this.campaigns.length ? this.campaigns : [{}];
   return dataSrc.map(campaign => ({
        'Name': {
          value: campaign.name,
          action: null
        },
        'Frequency': {
          value: campaign.frequency,
          action: null
        },
        'Description': {
          value: campaign.description,
          action: null
        },
        'Status': {
          value: 'Active',
          action: null
        }
      }));
  }

  exportCSV() {
    if (this.tidyTable) {
      this.tidyTable.exportCsv(this.tidyTable.tabledataSource);
    } else {
      this.util.showError('No data to export', 5000);
    }
  }

}
